var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StandardLayout',[_c('div',{staticClass:"mx-12 my-6",attrs:{"slot":"main"},slot:"main"},[_c('Hero'),_c('Explainer'),_c('FeaturedCreations'),_c('FeaturedCreators'),_c('FeaturedGuilds')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }